<template>
    <div>
        <div class="left">
            <Table :columns="columns" :data="list.body"></Table>
            <br />
            <Page
                    size="small"
                    :total="list.page.count"
                    :page-size="list.page.page_size"
                    @on-change="changePage"
                    show-total
            />
        </div>
        <div class="right">
            <Menu mode="horizontal" theme="light" :active-name="currentComponent" @on-select="selectMenu">
                <MenuItem name="notebook">
                    Notebook
                </MenuItem>
                <MenuItem name="comments">
                    评论
                </MenuItem>
            </Menu>
            <keep-alive>
                <component :is="currentComponent" :userCode="userCode" :show="loadingShow" :competJoinId="currentCompetJoinId"></component>
            </keep-alive>

<!--            <Tabs value="name1">-->
<!--                <TabPane label="Notebook" name="name1">-->
<!--                    <div id='doc'></div>-->
<!--                </TabPane>-->
<!--                <TabPane label="评论" name="name2">-->
<!--                    <COMMENTS :comments-list="comments" :total="commentsTotal" :page-num="commentsPageNum" :page-size="commentsPageSize" :loading="commentsLoading" :page-change="commentsPageChange" :submit-comments="submitComment"></COMMENTS>-->
<!--                </TabPane>-->
<!--            </Tabs>-->
        </div>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'
    import COMMENTS from '../../common/comments'

    import Notebook from './comments/notebook'
    import Comments from './comments/comments'

    export default {
        components: {
            COMMENTS,
            Notebook,
            Comments
        },
        props:{
            replaceId:{
                type:String,
            }
        },
        data() {
            return {
                loadingShow:true,
                currentComponent:'notebook',
                currentCompetJoinId:'',
                currentContestId:'',
                replyShow: false,
                userCode:"",
                currentReplyId: 0,
                currentReplyName: "",
                commentButtonName: "发布",
                pageSize:10,
                pageNum:2,

                columns: [
                    {
                        title: '姓名',
                        key: 'name',
                        render: (h, params) => {
                            return h('div', [
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color: '#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.getUserCode(params.row.code_info.file_uuid,this.currentContestId);
                                        }
                                    }
                                }, params.row.name),
                            ]);
                        }
                    },
                    {
                        title: '分数',
                        key: 'score'
                    },
                    {
                        title: '排名',
                        key: 'rank'
                    }
                ],
                list:{
                    body:[],
                    page:{
                        count:0,
                        page_num:0,
                        page_size:0
                    }
                },
            }
        },
        methods: {
            ...mapActions({
                getOpenList:'contest/getOpenList',
                getOpenUserCode:'contest/getOpenUserCode',
            }),
            selectMenu(name){
                this.currentComponent = name;
            },
            // 分页变动
            changePage(page){
                this.page_num = page;
                this.getList(0)
            },
            reply(authorId, authorName) {
                this.replyShow = true;
                this.currentReplyId = authorId;
                this.currentReplyName = authorName;
                this.commentButtonName = "回复";

            },
            closeReply() {
                this.replyShow = false;
                this.currentReplyName = "";
                this.currentReplyId = 0;
                this.commentButtonName = "发布";
            },
            // 获取用户公开code和评论信息
            getUserCode(file_uuid,contestId){
                let _this = this;
                _this.getOpenUserCode({
                    data:{
                        uid:file_uuid,
                        contest_id:contestId
                    },
                    callback:res=>{
                        _this.userCode = res.content;
                        _this.loadingShow = false;
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                    }
                })
            },
            // 获取列表
            getList(loadCode){
                let _this = this;
                // 获取公开信息
                this.getOpenList({
                    contest_id:_this.currentContestId,
                    data:{
                        page_num:_this.pageNum,
                        page_size:_this.pageSize
                    },
                    callback:res=>{
                        _this.list = res;
                        // 根据返回结果获取第一条Code
                        if(res.body.length > 0 && loadCode === 1){
                            _this.currentCompetJoinId = res.body[0].compet_join_id;
                            _this.getUserCode(res.body[0].code_info.file_uuid,_this.currentContestId);
                        }else{
                            _this.loadingShow = false;
                        }
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                    }
                })
            }
        },
        mounted() {
            let id = this.$route.params.id;
            if(id > 0){
                this.currentContestId = id;
            }else{
                this.$router.push({
                    name:"contest"
                })
            }
            // 是否有锚点
            if(this.replaceId > 0 ){
                this.getList(0);
                this.getUserCode(this.replaceId,this.currentContestId);
            }else{
                this.getList(1);
            }
        }
    }
</script>
<style scoped>
    .left {
        width: 30%;
        float: left;
    }

    .right {
        padding-left: 10px;
        width: 69%;
        float: left;
    }

    .comment-list {
        padding-left: 48px;
    }

    .comment-block {
        -ms-flex-align: start;
        align-items: flex-start;
        display: -ms-flexbox;
        display: flex;
        margin-top: 12px;
        padding-bottom: 12px;
    }

    .comment-list li {
        border-top: 1px solid #f5f5f5;
        -ms-flex-align: start;
        align-items: flex-start;
        display: -ms-flexbox;
        display: flex;
        font-size: 12px;
        padding: 20px 0;
    }

    .comment-list .avatar {
        display: block;
        -ms-flex-positive: 0;
        flex-grow: 0;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        width: 44px;
        height: 44px;
        border-radius: 50%;
        margin-right: 16px;
    }

    .comment-content {
        width: 100%;
    }

    .comment-list li .action {
        font-size: 13px;
        margin-top: 6px;
        text-align: right;
    }

    .comment-list li .userinfo-wrapper {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: justify;
        justify-content: space-between;
    }

    .input-block {
        flex-grow: 1;
    }

    .avatar {
        display: block;
        -ms-flex-positive: 0;
        flex-grow: 0;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        width: 44px;
        height: 44px;
        border-radius: 50%;
        margin-right: 16px;
    }
</style>
